import * as React from 'react';
import type { SVGProps } from 'react';
const SvgColorSwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.5 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 6.75a2 2 0 0 1 2-2h4.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2h-4.5a2 2 0 0 1-2-2zM15.75 15.25l2.93-2.992a2 2 0 0 0 .028-2.77l-3.08-3.273c-.755-.803-2.438-.415-2.438-.415"
    />
  </svg>
);
export default SvgColorSwatch;
